import styled, { css } from "styled-components";
import theme from "styled-theming";
import colors from "../styles/colors";
import { ThemeType } from "../styles/theme";

const AgentStatusOnlineColor = theme("mode", {
    [ThemeType.light]: colors.uiGreen,
    [ThemeType.dark]: colors.greenPrimary,
});

const AgentStatusInactiveColor = theme("mode", {
    [ThemeType.light]: colors.grey_1,
    [ThemeType.dark]: colors.grey_3,
});

const AgentStatusErrorColor = theme("mode", {
    [ThemeType.light]: colors.warningDark,
    [ThemeType.dark]: colors.warningSecondary,
});

const AgentStatusStyle = css`
    display: inline;
    margin-left: 10px;
    font-weight: 600;
    overflow-wrap: break-word;
    word-break: break-word;
`

export const AgentStatusOnline = styled.span`
    ${AgentStatusStyle}
    color: ${AgentStatusOnlineColor};
`

export const AgentStatusInactive = styled.span`
    ${AgentStatusStyle}
    color: ${AgentStatusInactiveColor};
`

export const AgentStatusError = styled.span`
    ${AgentStatusStyle}
    color: ${AgentStatusErrorColor};
`
